<template>
  <el-col
    v-if="filterConfig && showStatus"
    :span="filterConfig.span || undefined"
    :style="colStyle"
    :class="{
      'col-wrap':true,
      'current':!disabled && currentElementIndexStr == itemIdxStr,
      'col-wrap-edit':!disabled,
      [filterConfig.classStyle||'']:true,
      'un-col-flex-wrap':!filterConfig.span
    }"
    :data-target-level-keys="disabled ? undefined : itemIdxStr"
    :data-can-move-up="(idx > 0) + ''"
    :data-can-move-down="(idx < listLength - 1) + ''"
    :data-component-name="'Col'"
  >
    <!-- 渲染 element-item 组件 -->
    <element-item
      v-if="filterConfig.items && filterConfig.items.length"
      v-for="(item, itemIdx) in filterConfig.items"
      :key="itemIdx"
      :disabled="!edit"
      :allArcListMap="getArcListMap(item)"
      :parentKeys="[...parentKeys, idx]"
      :item-data="item"
      :currentElementIndex="currentElementIndex"
      :idx="itemIdx"
      :list-length="filterConfig.items.length"
    ></element-item>

 
  </el-col>
</template>

<script setup>
import { computed } from 'vue'; 
import { useElementIndex,toSetElementStyle } from './uses/elementIndexUse.js';
import { ElCol } from 'element-plus';
import 'element-plus/es/components/col/style/css';
import { useRenderConfig } from './uses/useRenderConfig.js';

// 获取 props
const props = defineProps({
  allArcListMap: { type: Object, default: () => ({}) },
  parentKeys: {
    type: Array,
    default: () => [],
  },
  disabled: {
    type: Boolean,
    default: true,
  },
  config: {
    type: Object,
    default: () => ({}),
  },
  idx: {
    type: Number,
    default: -1,
  },
  listLength: {
    type: Number,
    default: 0,
  },
  currentElementIndex: {
    type: Array,
    default: () => [],
  },
});

// 使用 useElementIndex 来复用 index 逻辑
const {   currentElementIndexStr, itemIdxStr } = useElementIndex(props);
const { bindData, filterConfig, showStatus } = useRenderConfig(() => props.config);

// 编辑模式
const edit = computed(() => !props.disabled);

// 动态计算 Col 样式
const colStyle = computed(() => {
  const config = filterConfig.value || props.config || {};
  let setStyle = toSetElementStyle(config, bindData.value);
  return {
    border: config.shadow ? '1px solid #f3f3f3' : undefined,
    backgroundColor: config.backgroundColor,
    backgroundImage: config.backgroundImage ? `url(${config.backgroundImage})` : undefined,
    paddingTop: `${config.padding?.top || 0}px`,
    paddingBottom: `${config.padding?.bottom || 0}px`,
    paddingLeft: `${config.padding?.left || 0}px`,
    paddingRight: `${config.padding?.right || 0}px`,
    marginTop: `${config.margin?.top || 0}px`,
    marginBottom: `${config.margin?.bottom || 0}px`,
    marginLeft: `${config.margin?.left || 0}px`,
    marginRight: `${config.margin?.right || 0}px`,
    borderTopLeftRadius: config.radius ? `${config.radius.leftTop}px` : '0',
    borderTopRightRadius: config.radius ? `${config.radius.rightTop}px` : '0',
    borderBottomLeftRadius: config.radius ? `${config.radius.leftBottom}px` : '0',
    borderBottomRightRadius: config.radius ? `${config.radius.rightBottom}px` : '0',
    width: !config.span ? (typeof config.width === 'number' ? `${config.width}px` : 'auto') : undefined,
    height: typeof config.height === 'number' ? `${config.height}px` : 'auto',
    flexDirection: config.isColumn ? 'column' : undefined,
    display: config.isFlex || config.isColumn ? 'flex' : undefined,
    justifyContent: config.isFlex || config.isColumn ? config.justifyContent : undefined,
    alignItems: config.isFlex || config.isColumn ? config.alignItems : undefined,
    ...setStyle,
  };
});

 

// 获取文章列表数据
const getArcListMap = (item) => {
  return item.type === 'articleListItem' || item.type === 'row' || item.type === 'col' || item.type === 'tabsItem'
    ? props.allArcListMap
    : undefined;
};
</script>

<style scoped>
.col-wrap {
  position: relative;
  background-size: 100% auto;
  background-position: center top;
}
 
.col-wrap-edit:hover::before {
  display: block;
}

.col-wrap-edit::before {
  content: " ";
  display: none;
  position: absolute;
  pointer-events: none;
  right: 0;
  left:0;
  top: 0;
  bottom: 0;
  z-index: 1112;
  border: 1px dashed #999;
}

.col-wrap-edit.current::before {
  display: block;
  border: 1px solid #276af4 !important;
 
}
 
  
.un-col-flex-wrap{
  flex: none;
}
</style>
